import React from 'react';
import { humanSize } from '../utils/files';

const PROVIDER_AR = { google_drive: 'قوقل درايف', onedrive: 'ون درايف' };

/**
 * عرض مرفقات التذكرة: ملفات مرفوعة وروابط مشاركة من قوقل درايف/ون درايف.
 * onRemove اختياري — يظهر زرّ الحذف فقط لمن يملك التعديل.
 */
export default function RequestAttachments({ items, onRemove }) {
  if (!items?.length) {
    return <div style={{ fontSize: 13, color: 'var(--text-faint, var(--text-faint))' }}>لا توجد مرفقات</div>;
  }

  return (
    <div style={{ display: 'grid', gap: 6 }}>
      {items.map(a => (
        <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
          <span>{a.kind === 'link' ? (a.provider === 'onedrive' ? '☁️' : '🔗') : '📎'}</span>
          <a href={a.file_url} target="_blank" rel="noreferrer" style={{ flex: 1 }}>{a.file_name}</a>
          <span style={{ color: 'var(--text-faint)', fontSize: 11 }}>
            {a.kind === 'link' ? (PROVIDER_AR[a.provider] || 'مشاركة') : humanSize(a.file_size)}
          </span>
          {onRemove && <button className="btn-icon" title="حذف" onClick={() => onRemove(a)}>✕</button>}
        </div>
      ))}
    </div>
  );
}
